angular.module('ui.order.orderItemCard.orderItemFiles.checkDuplicatesService', [])

    .service('checkDuplicatesService', function () {
        var result;
        var _this = this;

        //_this.checkConflicts = function (filesToUpload) {
        //    _this.notConflicted=[];
        //    _this.conflicted=[];
        //    var uploadedFiles = _this.getAlreadyUploadedFiles();
        //    if (uploadedFiles) {
        //        angular.forEach(filesToUpload, function (value, key) {
        //            var res = _.find(uploadedFiles, function (element, key) {
        //                return value.name == element.$model.fileName ;
        //            });
        //            if(!res) _this.notConflicted.push(value);
        //            if(res) _this.conflicted.push(value);
        //        });
        //    } else {
        //        toastr.error(null, gettextCatalog.getString("Can't get a list of uploaded files"));
        //    }
        //};
        _this.file;
        _this.isDuplicate = function (name) {
            var uploadedFiles = _this.getAlreadyUploadedFiles();
            if (uploadedFiles) {
                var res = _.find(uploadedFiles, function (element, key) {
                    return name == element.$model.fileName;
                });
                if (res) return res.$model.id;
            } else {
                toastr.error(null, gettextCatalog.getString("Can't get a list of uploaded files"));
            }
        };
        _this.generateNewName = function (name) {
            var onlyName = name.substring(0, name.lastIndexOf("."));
            var extension = name.substring(name.lastIndexOf("."), name.length);
            for (var i = 1; true; i++) {
                var tryName = onlyName + " (" + i + ")" + extension;
                if (!_this.isDuplicate(tryName))return tryName;
            }
        };
        //_this.handlePause = function(pauseDeferred){
        //    _this.pauseDeferred = pauseDeferred;
        //};


        function findAndIncrement(uploadedFiles, filesToUpload) {
            //angular.forEach(filesToUpload, function (value, key) {
            //
            //    var found = _.find(uploadedFiles, function (element, key) {
            //        return value.name == element.$model.fileName
            //    });
            //    var i = 1;
            //    var indexOfFound = uploadedFiles.indexOf(found);
            //    do {
            //
            //        found.$model.fileName = changeName(found.$model.fileName, i);
            //        i++;
            //    }
            //    while (found);
            //    if (found) {
            //
            //    }
            //
            //});
        }

        //_this.getNotConflicted = function (filesToUpload) {
        //    _this.notConflicted=[];
        //    _this.conflicted=[];
        //    var uploadedFiles = _this.getAlreadyUploadedFiles();
        //    if (uploadedFiles) {
        //        angular.forEach(filesToUpload, function (value, key) {
        //           var res = _.find(uploadedFiles, function (element, key) {
        //                 return value.name == element.$model.fileName ;
        //            });
        //            if(!res) _this.notConflicted.push(value);
        //            if(res) _this.conflicted.push(value);
        //        });
        //    } else {
        //        toastr.error(null, gettextCatalog.getString("Can't get a list of uploaded files"));
        //    }
        //    return _this.notConflicted;
        //};
        //_this.getConflicted = function(filesToUpload){
        //
        //    _this.conflicted=[];
        //    var uploadedFiles = _this.getAlreadyUploadedFiles();
        //    if (uploadedFiles) {
        //        angular.forEach(filesToUpload, function (value, key) {
        //            var res = _.find(uploadedFiles, function (element, key) {
        //                return value.name == element.$model.fileName ;
        //            });
        //            if(res) _this.conflicted.push(value);
        //        });
        //    } else {
        //        toastr.error(null, gettextCatalog.getString("Can't get a list of uploaded files"));
        //    }
        //};
        function changeName(name, i) {
            var lastIndex = name.lastIndexOf(".");
            name = name.substring(0, 8) + "(" + i + ")" + name.substring(9);
        }

        return _this;
    });